/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect } from 'react';
import { MyContext } from '../Context/MyProvider';
import axios from 'axios';
import secureLocalStorage from "react-secure-storage";
const SenangPay = ({ Amount }) => {

    const { ApiBaseUrl, setApiLoading } = useContext(MyContext);

    const HandleCall = () => {
        const Userid = secureLocalStorage.getItem("Userid");

        setApiLoading(true);
        axios.post(`${ApiBaseUrl}/customer/senangpay-payment`, { amount: Amount, uid: Userid, status: "1", })
            .then((res) => {
                // console.log("senangpay-payment", res);
                setTimeout(() => {
                    setApiLoading(false);
                }, 1000);
                window.location.href = res.data.SenangPayURL;
            })
            .catch((error) => {
                console.error(error);
            });
    };

    useEffect(() => {
        if (Amount) {
            HandleCall();
        }
    }, [Amount]);

    return null;
};

export default SenangPay;
/* jshint ignore:end */